import Content from "./Content";

export default class TaskContent extends Content {
    constructor(languagePack, contentID, title, description, dateTimeOffset, completed, label) {
        super(TaskContent.NAME, TaskContent.TYPE, label, languagePack, contentID);

        this.setTitle(title);
        this.setDescription(description);

        this._dateTimeOffset = dateTimeOffset;
        this._completed = completed;
    }

    setTitle(value) {
        if (this.getTitle() !== value) {
            this.setLanguagePackText(TaskContent.TITLE_LABEL, value);
        }
    }

    getTitle() {
        return this.getLanguagePackText(TaskContent.TITLE_LABEL);
    }

    setDescription(value) {
        if (this.getDescription() !== value) {
            this.setLanguagePackText(TaskContent.DESCRIPTION_LABEL, value);
        }
    }

    getDescription() {
        return this.getLanguagePackText(TaskContent.DESCRIPTION_LABEL);
    }

    setDateTimeOffset(value) {
        this._dateTimeOffset = value;
    }

    getDateTimeOffset() {
        return this._dateTimeOffset;
    }

    setCompleted(value) {
        this._completed = value;
    }

    getCompleted() {
        return this._completed;
    }

    convertToObject() {
        return this.getObject(["dateTimeOffset", "completed"]);
    }
}


TaskContent.NAME = "Task";
TaskContent.TYPE = "engTaskContent";
TaskContent.TITLE_LABEL = "title";
TaskContent.DESCRIPTION_LABEL = "description";